import script from "./property.vue?vue&type=script&lang=ts&setup=true"
export * from "./property.vue?vue&type=script&lang=ts&setup=true"

import "./property.vue?vue&type=style&index=0&id=1565e35e&lang=less&scope=true"

const __exports__ = script;

export default __exports__